// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2IiUG","dragIcon":"SortableItem_dragIcon__1INOE","disabled":"SortableItem_disabled__3trqH"};